import React from "react";
import style from "./Pagina404.module.css";
import { NavLink } from "react-router-dom";
import imgFront from "../../assests/imagenes/La_Romana_logo_completo_color.svg";

export default function Pagina404() {
  return (
    <div className={style.contenedor_404}>
      <img src={imgFront} alt="Logo" className={style.logo_404} />
      <h1 className={style.titulo_404}>404 - Página no encontrada</h1>
      <p className={style.mensaje_404}>
        Lo sentimos, la página que buscas no existe o ha sido movida.
      </p>
      <button className={style.btn_vovler}>
        {" "}
        <NavLink to="/">Volver al inicio</NavLink>
      </button>
    </div>
  );
}
